import { inject, provideAppInitializer } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowTrendUp,
  faBriefcase,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleXmark,
  faExclamation,
  faMoneyBillWave,
  faMinus,
  faPlay,
  faPlus,
  faScaleBalanced,
  faWallet,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

const FONT_AWESOME_ICONS = [
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowTrendUp,
  faBriefcase,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleXmark,
  faClock,
  faExclamation,
  faMoneyBillWave,
  faMinus,
  faPlay,
  faPlus,
  faScaleBalanced,
  faWallet,
  faXmark,
];

export const provideFontAwesomeIcons = () =>
  provideAppInitializer(() => {
    inject(FaIconLibrary).addIcons(...FONT_AWESOME_ICONS);
  });
